import Api from '@/modules/core/api/api.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { TimezoneDto } from '@/modules/counterparty/dto/timezone.dto.ts';
import { TimezoneAdapter } from '@/modules/counterparty/adapters/timezone.adapter.ts';
import { TimezoneEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';
import { SystemApi } from '@/modules/core/api/system.api.ts';
import { DateTime } from 'luxon';
import i18n from '@/i18n.ts';

export class TimezoneApi {
  static async getList(signal?: AbortSignal) {
    const [response, serverTime]: [ItemsDto<TimezoneDto>, Awaited<ReturnType<typeof SystemApi.getServerTime>>] =
      await Promise.all([
        Api.post(TimezoneEndPoint.GetList, RequestUtil.orderBy('Описание', Direction.Asc), signal),
        SystemApi.getServerTime(signal ?? new AbortController().signal),
      ]);

    const serverZone = DateTime.now().setZone(serverTime.timezone);
    const serverOffsetMinutes = serverZone.isValid ? serverZone.offset : DateTime.local().offset;
    const serverRegion =
      (typeof serverTime.location === 'string' ? serverTime.location.trim() : '') ||
      i18n.global.t('counterparty.field.timezoneServerRegion');

    return TimezoneAdapter.mapList(response, serverOffsetMinutes, serverRegion);
  }
}
